import React, { FC } from 'react'

import { CardProps } from '../../../Card'
import { FormikFormProps } from '../../../form/FormikForm'
import { FormFieldInputProps } from '../../../form/fields/FormFieldInput'
import { FormErrorsProps } from '../../../form/FormErrors'
import { FormSubmitButtonProps } from '../../../form/FormSubmitButton'
import FormikField from '../../../form/FormikField'
import BoxedContent from '../../../BoxedContent'

import * as SC from './styled'

export type ForgotPasswordValues = {
  email: string
}

export type ForgotPasswordFormProps = {
  className?: string
  background: string
  header: CardProps['header']
  content: {
    title: string
    formikForm: FormikFormProps<ForgotPasswordValues>
    fields: {
      email: FormFieldInputProps
    }
    errors?: FormErrorsProps['errors']
    submitButton: FormSubmitButtonProps
  }
}

const ForgotPasswordForm: FC<ForgotPasswordFormProps> = (props) => {
  const { className, background, header, content } = props
  const { title, formikForm, fields, errors, submitButton } = content

  return (
    <SC.Container className={className} $background={background}>
      <BoxedContent>
        <SC.CardWrapper className={className} header={header}>
          <SC.Title>{title}</SC.Title>
          <SC.Form className={className} {...formikForm}>
            <SC.Fields>
              <FormikField {...fields.email} Component={SC.FieldText} />
            </SC.Fields>
            {errors && <SC.Errors errors={errors} />}
            <SC.SubmitButton {...submitButton} />
          </SC.Form>
        </SC.CardWrapper>
      </BoxedContent>
    </SC.Container>
  )
}

export default ForgotPasswordForm
